import React, { useState } from "react";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import ImageGrid from "../components/ImageGrid";
import ImageListView from "../components/ImageListView";
import Footer from "../components/Footer";

const photos = [
  {
    src: "/images/vj2.jpg",
    description: "U čemu problem?",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj3.jpg",
    description: "Ništa lično...♠️📷 #luckyshot",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj4.jpg",
    description: "Ne znam gde sam koliko mi je dobro 😎😂",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj5.jpg",
    description: "Sad sve prestaje da bude važno 😎🌻",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj6.jpg",
    description: "You'll see that life is still worth while, if you just smile 😉",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj7.jpg",
    description: "🇮🇹🤌",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj8.jpg",
    description: "😌👌è buono",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj9.jpg",
    description: "Ti amo, Firenze ☕",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj10.jpg",
    description: "Just breathe #mountainhike",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj11.jpg",
    description: "🏂",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj12.jpg",
    description: "Ne može biti bolje od ovoga 🤪",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj13.jpg",
    description: "#miamivice 🌆",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj14.jpg",
    description: "Nećemo da preterujemo...",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj15.jpg",
    description: "#nbgblocklife",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj16.jpg",
    description: "🏖️",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj17.jpg",
    description: "#eventhorizon",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj18.jpg",
    description: "Neke navike ne treba menjati...",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj19.jpg",
    description: "About last night",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
  {
    src: "/images/vj20.jpg",
    description: "#beergarden",
    tags: [{ name: "Mr Wolf", url: "/facegram-phone/mr-wolf" }],
  },
];

export default function InstagramMobileVJ({
  username = "mr.wolf",
  bio = "Life is supposed to be fun! content creator",
  avatarUrl = "/images/vj1.jpg",
  posts = 258,
  followers = "524",
  following = 300,
}) {
  const [activeTab, setActiveTab] = useState("grid");
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <div className="ph-wrap">
      <div className="ph-top">
        <div className="ph-avatar-ring">
          <img
            className="ph-avatar"
            src={avatarUrl}
            alt={`${username} avatar`}
          />
        </div>

        <div className="ph-user">
          <div className="ph-row">
            <div className="ph-username">{username}</div>
          </div>
          <div className="ph-bio">{bio}</div>
        </div>
        <div className="ph-button">
          <button className="ph-more" aria-label="More options">
            ⋯
          </button>
        </div>
      </div>
      <div className="ph-actions">
        <button className="ph-btn-following">Following</button>
        <button className="ph-btn-message">Message</button>
        <button className="ph-btn-icon" aria-label="Add">
          <span className="ph-plus">＋</span>
        </button>
      </div>
      <div className="ph-stats">
        <div className="ph-stat">
          <div className="ph-num">{posts}</div>
          <div className="ph-label">posts</div>
        </div>
        <div className="ph-stat">
          <div className="ph-num">{followers}</div>
          <div className="ph-label">followers</div>
        </div>
        <div className="ph-stat">
          <div className="ph-num">{following}</div>
          <div className="ph-label">following</div>
        </div>
      </div>
      <div className="profile-tabs">
        <GridOnOutlinedIcon
          className={`tab-icon ${activeTab === "grid" ? "active" : ""}`}
          fontSize="large"
          onClick={() => handleTabClick("grid")}
        />

        <ViewListOutlinedIcon
          className={`tab-icon ${activeTab === "list" ? "active" : ""}`}
          fontSize="large"
          onClick={() => handleTabClick("list")}
        />

        <SearchOutlinedIcon
          className={`tab-icon ${activeTab === "search" ? "active" : ""}`}
          fontSize="large"
          onClick={() => handleTabClick("search")}
        />

        <BookmarkBorderOutlinedIcon
          className={`tab-icon ${activeTab === "saved" ? "active" : ""}`}
          fontSize="large"
          onClick={() => handleTabClick("saved")}
        />
      </div>
      {activeTab === "grid" ? (
        <ImageGrid images={photos} />
      ) : (
        <ImageListView images={photos} />
      )}
      <Footer page="home" />
    </div>
  );
}
